import React, { useEffect, useState } from "react";
import Video from "twilio-video";
import Participant from "./Participant";
import "./App.css";
import { Grid, GridItem, HStack } from "@chakra-ui/layout";

const TwilioRoom = ({
    roomName,
    token,
    handleLogout,
    muteAudio,
    disableVideo
}) => {
    const [room, setRoom] = useState(null);
    const [participants, setParticipants] = useState([]);

    useEffect(() => {
        const participantConnected = (participant) => {
            setParticipants((prevParticipants) => [...prevParticipants, participant]);
        };

        const participantDisconnected = (participant) => {
            setParticipants((prevParticipants) =>
                prevParticipants.filter((p) => p !== participant)
            );
        };

        Video.connect(token, {
            name: roomName,
            dominantSpeaker: true,
            audio: true,
            video: true,
            automaticSubscription: true,
            logLevel: "debug"
        }).then((room) => {
            setRoom(room);
            room.on("participantConnected", participantConnected);
            room.on("participantDisconnected", participantDisconnected);
            room.participants.forEach(participantConnected);
        });

        return () => {
            setRoom((currentRoom) => {
                if (currentRoom && currentRoom.localParticipant.state === "connected") {
                    currentRoom.localParticipant.tracks.forEach(function (
                        trackPublication
                    ) {
                        trackPublication.track.stop();
                    });
                    currentRoom.disconnect();
                    return null;
                } else {
                    return currentRoom;
                }
            });
        };
    }, [roomName, token]);

    const remoteParticipants = participants.map((participant) => (
        <Participant key={ participant.sid } participant={ participant } />
    ));

    useEffect(() => {
        if (room) {
            room.localParticipant.audioTracks.forEach(function ({ track }) {
                if (muteAudio) {
                    track.disable();
                } else {
                    track.enable();
                }
            });
        }
    // eslint-disable-next-line
  }, [muteAudio, room]);

    useEffect(() => {
        if (room) {
            room.localParticipant.videoTracks.forEach(function ({ track }) {
                if (disableVideo) {
                    track.disable();
                } else {
                    track.enable();
                }
            });
        }
    // eslint-disable-next-line
  }, [disableVideo, room]);

    return (
        <div className="room">
            <Grid
                templateColumns="repeat(5, 1fr)"
                gap={ 4 }
                minH="300px"
                margin="20px 0"
            >
                <GridItem colSpan={ 4 }>
                    <HStack>{ remoteParticipants }</HStack>
                </GridItem>
                <GridItem colStart={ 5 } colEnd={ 6 }>
                    { room ? (
                        <Participant
                            key={ room.localParticipant.sid }
                            participant={ room.localParticipant }
                        />
                    ) : (
                        ""
                    ) }
                </GridItem>
            </Grid>
        </div>
    );
};

export default TwilioRoom;
